/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { withStyles } from '@material-ui/core/styles';
import {
  Hidden,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  FormControl,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowForward from '@material-ui/icons/ArrowForward';

import appContent from 'aurora-api/dummy/appContent';
import messages from 'aurora-translations';
import { TextFieldRedux } from './AuroraStatefulForm';
import styles from './auth-jss';

const required = value => (value === null ? 'Required' : undefined);
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email' : undefined;

function LoginForm(props) {
  const { classes, handleSubmit, pristine, submitting, intl, loading, failure, errorMessage } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = event => event.preventDefault();

  return (
    <Paper className={classes.sideWrap}>
      <Hidden mdUp>
        <div className={classes.headLogo}>
          <NavLink to='/' className={classes.brand}>
            {appContent.name}
          </NavLink>
        </div>
      </Hidden>

      <div className={classes.topBar}>
        <Typography variant='h4' className={classes.title}>
          <FormattedMessage {...messages.login} />
        </Typography>
      </div>

      {failure && <Alert severity='error'>{errorMessage}</Alert>}

      <section className={classes.pageFormSideWrap}>
        <form onSubmit={handleSubmit}>
          <div>
            <FormControl className={classes.formControl}>
              <field
                name='username'
                component={TextFieldRedux}
                placeholder={intl.formatMessage(messages.loginFieldEmail)}
                label={intl.formatMessage(messages.loginFieldEmail)}
                required
                validate={[required, email]}
                className={classes.field}
              />
            </FormControl>
          </div>
          <div>
            <FormControl className={classes.formControl}>
              <field
                name='password'
                component={TextFieldRedux}
                type={showPassword ? 'text' : 'password'}
                label={intl.formatMessage(messages.loginFieldPassword)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='Toggle password visibility'
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                required
                validate={required}
                className={classes.field}
              />
            </FormControl>
          </div>
          <div className={classes.btnArea}>
            <Button variant='contained' disabled={loading} fullWidth color='primary' size='large' type='submit'>
              {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              <FormattedMessage {...messages.loginButtonContinue} />
              {!loading && (
                <ArrowForward
                  className={classNames(classes.rightIcon, classes.iconSmall, classes.signArrow)}
                  disabled={submitting || pristine}
                />
              )}
            </Button>
          </div>
        </form>
      </section>
    </Paper>
  );
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  failure: PropTypes.bool,
};

LoginForm.defaultProps = {
  loading: false,
  failure: false,
  errorMessage: '',
};

export default withStyles(styles)(injectIntl(LoginForm));
